import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { ScrollToTop } from "../../components/ScrollToTop";

type IOverlaySupport = {
    footerHeightRem: number,
    preFooterHeightRem?: number
}

export const OverlaySupport = ({ footerHeightRem, preFooterHeightRem = 0 }:IOverlaySupport) => {

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  let footerOffset = (isMobile ? footerHeightRem - 4 : footerHeightRem) + (preFooterHeightRem + 1);

  return (
    <Stack id="overlayTrailStickyElements"
      sx={ {
        pointerEvents: "none",
        position: "absolute",
        height: `calc(100% - ${!isMobile ? footerOffset : "0"}rem)`, // in mobile the overlay box is placed on the bottom of the footer
        top: 0,
        right: 0,
        zIndex: 9
      } }
    >
      <Stack id="stickyElements"  sx={ {
        position: "sticky",
        alignItems: "flex-end",
        top: `calc(100% - ${!isMobile ? footerOffset : 13 + preFooterHeightRem}rem)`, // in mobile the overlay box is placed on the bottom of the footer and need a fixed offset (13rem)
        gap: isMobile ? "2rem" : "4rem",
        zIndex: 9
      } }
      >
        <ScrollToTop />
      </Stack>
    </Stack>
  );
};
